import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

type Props = {
    children: React.ReactNode
}

export function SettingsLayout({ children }: Props) {
    return (
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
            }}
        >
            {children}
        </Container>
    )
}

type SettingsSectionProps = {
    header: string
    children: React.ReactNode
    subHeader?: string
}

export function SettingsSection({ header, children, subHeader }: SettingsSectionProps) {
    return (
        <>
            <div>
                <Typography gutterBottom={!!subHeader} variant="h5" fontWeight={500}>
                    {header}
                </Typography>
                {subHeader && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        dangerouslySetInnerHTML={{ __html: subHeader }}
                    />
                )}
            </div>
            <Stack component={Paper} sx={{ p: 4, gap: 2 }}>
                {children}
            </Stack>
        </>
    )
}
